import { Text } from '@thanx/uikit/text'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import type { PermissionValue } from './PermissionRow'

type Props = {
  option: { label: string; val: PermissionValue }
  resourceName: string
  checked: boolean
  disabled: boolean
  isLocked: boolean
  lockedTooltip?: string
  tooltipId: string
  onChange: (name: string, value: PermissionValue) => void
}

export const PermissionRadio = ({
  option,
  resourceName,
  checked,
  disabled,
  isLocked,
  lockedTooltip,
  tooltipId,
  onChange,
}: Props) => {
  const isOptionDisabled = disabled || isLocked
  const radio = (
    <label
      className={`d-flex align-items-center m-0 ${
        isOptionDisabled ? '' : 'cursor-pointer'
      }`}
    >
      <input
        type="radio"
        name={`permission-${resourceName}`}
        checked={checked}
        onChange={() => onChange(resourceName, option.val)}
        disabled={isOptionDisabled}
        className="mr-xs"
      />
      <Text.BodyText4 color="grey70" className="m-0">
        {option.label}
      </Text.BodyText4>
    </label>
  )

  if (isLocked && lockedTooltip) {
    return (
      <OverlayTrigger
        key={option.val}
        placement="top"
        overlay={
          <Tooltip id={`${tooltipId}-${option.val}`}>{lockedTooltip}</Tooltip>
        }
      >
        <span tabIndex={0} aria-label={lockedTooltip}>
          {radio}
        </span>
      </OverlayTrigger>
    )
  }

  return radio
}
